const Spinner = () => {
  return (
    <div id="responseLoading">
      <div className="circleSpin">
        <div className="circle"></div>
      </div>
    </div>
  );
};

export default Spinner;
